import { Alert, Grid, Typography } from '@mui/material';
import { DocumentData } from 'firebase/firestore';
import React, { useEffect, useState } from 'react';

import ModuleCard from 'components/dashboard/ModuleCard/ModuleCard';
import ModuleCardSkeleton from 'components/dashboard/ModuleCard/ModuleCardSkeleton';
import SkeletonWrapper from 'components/SkeletonWrapper/SkeletonWrapper';
import { getAllModules, getGroupModulesIds, getModules } from 'external/firebase/controllers/db';
import useAuth from 'hooks/useAuth';

import useLocales from 'hooks/useLocales';

interface ModulesProps {}

const Modules: React.FunctionComponent<ModulesProps> = () => {
    const { profile } = useAuth();
    const { translate } = useLocales();

    const [modules, setModules] = useState<DocumentData>([]);
    const [error, setError] = useState<string | undefined>();
    const [isLoading, setIsLoading] = useState(true);

    const fetchModules = async (group: string) => {
        try {
            const groupModulesIds = await getGroupModulesIds(group);
            const modules = await getModules(groupModulesIds);
            setModules(modules);
            setError(undefined);
        } catch (err) {
            console.log('failed to fetch modules', err);
            // FIXME: Handle error
            // setError(translate(err.code));
        } finally {
            setIsLoading(false);
        }
    };

    const fetchAllModules = async () => {
        try {
            const resModules = await getAllModules();
            setModules(resModules);
            setError(undefined);
            setIsLoading(false);
        } catch (err) {
            console.log('failed to fetch all modules', err);
            // FIXME: Handle error
            // setError(translate(resModules.code));
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (profile?.groups) {
            fetchModules(profile.groups[0] || '');
        } else if (profile?.role === 'admin' || profile?.role === 'teacher') {
            fetchAllModules();
        } else {
            setError(translate('group_not_assigned'));
            setIsLoading(false);
        }
    }, [profile?.groups]);

    return (
        <>
            {isLoading && (
                <Grid container spacing={3} justifyContent='center'>
                    <SkeletonWrapper>
                        <Grid item xs={12} md={10}>
                            <ModuleCardSkeleton />
                        </Grid>
                    </SkeletonWrapper>
                </Grid>
            )}

            {error && <Alert severity='error'>{error}</Alert>}

            {!isLoading &&
                (modules.length > 0 ? (
                    <Grid container spacing={3} justifyContent='center'>
                        {modules.map(module => (
                            <Grid item xs={12} md={10} key={module.id}>
                                <ModuleCard module={module} />
                            </Grid>
                        ))}
                    </Grid>
                ) : (
                    <Grid container spacing={3} justifyContent='center'>
                        <Typography variant='h6' sx={{ px: 5, mt: 10, mb: 5 }}>
                            {translate('no_modules_found')}
                        </Typography>
                    </Grid>
                ))}
        </>
    );
};

export default Modules;
